import React, { useEffect, useState } from "react";
import { FaEdit } from "react-icons/fa";
import { FaTrashCan } from "react-icons/fa6";

import 'common/css/master.css';


const RangesTable = (props) => {
    const { rangeId, setRangeId, lstRanges, editRange, deleteRange } = props; // Destructure rangeId and setRangeId from props


    // Define lstRanges directly in the component
    const colgrp = (
        <colgroup>
            <col width="25%" />
            <col width="25%" />
            <col width="25%" />
            <col width="25%" />
        </colgroup>
    );

    return (
        <div>
            <div className="col-md-12 col-xs-12 col-centered padding-remove">
                <table className="tableLayout1">
                    {colgrp} {/* Add colgroup here */}
                    <thead>
                        <tr>
                            <th>Distance (km)</th>
                            <th>Count</th>
                            <th>Fees</th>
                            <th>Action</th>
                        </tr>
                    </thead>
                </table>
                <div className="tableDiv" style={{ height: "50vh" }}>
                    <table className="tableLayout">
                        {colgrp} {/* Add colgroup here as well */}
                        <tbody>
                            {lstRanges ? lstRanges.map((range) => (
                                <tr
                                    key={range.rangeId}
                                    style={{
                                        backgroundColor: range.rangeId === rangeId ? "#f0f8ff" : "transparent",
                                        cursor: "pointer",
                                    }}
                                    onClick={() => setRangeId(range.rangeId === rangeId ? null : range.rangeId)} // Set the selected rangeId on row click
                                >
                                    <td>{range.km}</td>
                                    <td>{range.count}</td>
                                    <td>{range.fees}</td>
                                    <td>
                                        <div style={{ display: "flex", justifyContent: "space-evenly", alignItems: "center", }}>
                                            <FaEdit
                                                title='Edit PTM'
                                                onClick={e => { editRange(range.rangeId); e.stopPropagation(); }}
                                                color="gray"
                                                style={{ fontSize: "15px", cursor: "pointer" }}
                                            />
                                            <FaTrashCan
                                                title="Delete"
                                                onClick={e => { deleteRange(range.rangeId); e.stopPropagation(); }}
                                                color="red"
                                                style={{ fontSize: "15px", cursor: "pointer" }}
                                            />
                                        </div>
                                    </td>
                                </tr>
                            )) : null
                            }
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    );
};

export default RangesTable;